import { useRef, useState } from "react";
import AvatarUploade from "../../../components/form/AvatarUploade";
import Form from "../../../components/form/Form";
import PhoneInput from "../../../components/form/PhoneInput";
import TextBox from "../../../components/form/TextBox";
import { getUser, setUser, useHub } from "../../../core/Global";
import Icon from "../../../components/base/Icon";
import { Drawer, DrawerRef } from "../../../components/drawers/Drawer";


interface IProps {
    onClose: () => void
}
export default function AccountEditMobile(props: IProps) {

    const hub = useHub()
    const drawer = useRef<DrawerRef>(null)
    const user = getUser()
    const [working, workingSet] = useState<boolean>(false)

    return (
        <Drawer ref={drawer} title="Edit Account"
            onClose={props.onClose}>
            <Form id="user-edit-form-mobile" className="form"
                onSubmit={(body, callback) => {

                    workingSet(true);

                    setTimeout(() => {

                        hub.Put("/accounts/users/manage/update", {
                            ...body,
                            id: user?.id
                        }, res => {
                            if (res.success) {
                                setUser(res.data)
                                drawer.current?.close()
                            }
                            workingSet(false);
                        })

                    }, 500);



                }}>

                {/* <div className="mb-5">
                    <AvatarUploade type="avatars" name="avatar" imageUrl={user?.avatarUrl} defaultValue={user?.avatarUrlRelativePath} />
                </div> */}

                <TextBox label="First Name" name="firstName" value={user?.firstName} block labelUp />
                <TextBox label="Last Name" name="lastName" value={user?.lastName} block labelUp />

                <TextBox label="Email Address" name="email" value={user?.email} email block labelUp />

                <PhoneInput label="Phone" name="phone" defaultPhone={user?.phoneItem} block labelUp />

                {
                    user?.isTech &&
                    <TextBox label="Telegram ID" name="telegramUsername" value={user?.telegramUsername} block labelUp />
                }

                <button type="submit" className="btn btn-primary w-100 mb-3">
                    {
                        working ?
                            <>
                                <Icon icon="spinner-third" spin />
                                <span className="ms-2">Updating...</span>
                            </>
                            :
                            <>Update Account</>
                    }
                </button>

                <button type="button" className="btn btn-secondary w-100 mb-10"
                    onClick={e => drawer.current?.close()}>
                    Discard
                </button>

            </Form>
        </Drawer>
    )
}